import {
  AppBar,
  Box,
  Button,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import { useEffect, useState } from 'react';

import KenDialogBox from '../../../global_components/KenDialogBox';

import '../../../style/index.css';

import { getExamData, getExamModuleListData } from '../../../Utils/apiServices';
import KenLoader from '../../../Components/KenLoader';

import HeaderGrid1 from '../components/HeaderGrid1';
import KenDialog from '../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import KenInputField from '../../../global_components/KenInputField';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'EXAM DASHBOARD',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    height: '28px',
    width: '78px',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    // color: '#F14B2D',
    width: '100px !important',
    color: 'white',
    margin: '5px 5px',
    fontSize: '9px',
    background: 'orange',
    borderRadius: '10px',
    height: '35px',
    '&:hover': {
      background: 'orange',

      // color: 'white',
      // borderBottom: '#F14B2D',
    },
  },
  normal: {
    // color: '#505F79',
    width: '100px !important',
    color: 'white',
    margin: '5px 5px',
    fontSize: '9px',
    background: 'green',
    borderRadius: '10px',
    height: '35px',
    '&:hover': {
      background: '#00c04b',

      color: 'white',
      // border: '1px solid white',
    },
  },
  penddingButton: {
    // color: '#505F79',
    color: 'white',

    background: '#55b0cd',
    // background: '#27AE60',

    // background: 'white',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',
      color: 'white',
      // border: '1px solid white',
    },
  },

  errorEvulations: {
    // color: '#F14B2D',

    background: 'rgba(241, 75, 45, 0.2)',
    // background: 'white',
    // background: '#EB5757',

    borderRadius: '25px',
    border: '1px solid white',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: '#EB5757',
    '&:hover': {
      color: '#EB5757',
      background: 'rgba(241, 75, 45, 0.2)',

      // color: 'white',
      // borderBottom: '#F14B2D',
    },
  },
  grayButton: {
    // color: '#505F79',
    color: '#505F79',

    background: 'rgba(196, 196, 196,0.2)',
    // background: '#27AE60',

    // background: '#505F79',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(196, 196, 196,0.2)',

      color: '#505F79',
      // border: '1px solid white',
    },
  },
  viewButton: {
    // color: '#505F79',
    color: '#fff',

    // background: 'rgba(196, 196, 196, 0.2)',
    background: '##272727',

    borderRadius: 3,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    '&:hover': {
      color: '##272727',
      borderBottom: '#fff',
    },
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
      textAlign: 'left',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
      textAlign: 'left',
    },
  },
  dialogHeader: {
    width: '100px',
  },
}));

const selectDueInOptions = [
  // {
  //   label: 'Select Due Date',
  //   value: '',
  // },
  {
    label: '7 Days',
    value: '7',
  },
  {
    label: '15 Days',
    value: '15',
  },
  {
    label: '30 Days',
    value: '30',
  },
];

const selectExamTypeOptions = [
  // {
  //   label: 'Select Due Date',
  //   value: '',
  // },
  {
    label: 'End Term',
    value: 'End-term',
  },
  {
    label: 'Mid Term',
    value: 'Mid-term',
  },
];
const selectOptionsReason = [
  {
    label: 'Select Campus',
    value: '',
  },
  {
    label: 'Eligible',
    value: 'Eligible',
  },
  {
    label: 'Not Eligible',
    value: 'Not eligible',
  },
  {
    label: 'At Risk',
    value: 'At Risk',
  },
  {
    label: 'Under Review',
    value: 'Under Review',
  },
];
const selectOptionsQuestionPaper = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Not Approved',
    value: 'Not Approved',
  },
  {
    label: 'Approved',
    value: 'Approved',
  },
];
const selectOptionsInvigilation = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Not Assigned',
    value: 'Not Assigned',
  },
  {
    label: 'Assigned',
    value: 'Assigned',
  },
];
const selectOptionsSeatingPlan = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Not Created',
    value: 'Not Created',
  },
  {
    label: 'Created',
    value: 'Created',
  },
];
const ExamProgress = () => {
  const history = useHistory();
  const classes = useStyles();

  // Filter State

  const [filterDialog, setFilterDialog] = useState(false);
  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }
  const [selectValueCampus, setSelectValueCampus] = useState('');
  const [selectValue, setSelectValue] = useState('');
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
    setSelectValueSubject('');
  };

  const [selectValueCampus1, setSelectValueCampus1] = useState('');
  const handleSelectChangeCampus1 = (e) => {
    setSelectValueCampus1(e.target.value);
  };

  const [selectValueProgram, setSelectValueProgram] = useState('');
  const handleSelectChangePrograms = (e) => {
    setSelectValueProgram(e.target.value);
    setSelectValueCampus('');
    setSelectValueSubject('');
  };

  const [selectValueSubject, setSelectValueSubject] = useState('');
  const handleSelectChangeProgram = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueReason, setSelectValueReason] = useState(
    selectOptionsReason[0].value
  );
  const handleSelectChangeReason = (e) => {
    setSelectValueReason(e.target.value);
  };

  const [selectValueQuestionPaper, setSelectValueQuestionPaper] = useState(
    selectOptionsQuestionPaper[0].value
  );

  const handleSelectChangeQuestionPaper = (e) => {
    setSelectValueQuestionPaper(e.target.value);
  };

  const [selectValueSeatingPlan, setSelectValueSeatingPlan] = useState(
    selectOptionsSeatingPlan[0].value
  );

  const handleSelectChangeSeatingPlan = (e) => {
    setSelectValueSeatingPlan(e.target.value);
  };

  const [selectValueInvigilation, setSelectValueInvigilation] = useState(
    selectOptionsInvigilation[0].value
  );

  const handleSelectChangeInvigilation = (e) => {
    setSelectValueInvigilation(e.target.value);
  };

  const [selectReason, setSelectReasonTerm] = useState('');
  const handleSelectChangeRes = (e) => {
    setSelectReasonTerm(e.target.value);
  };

  const [selectNameOrRollNum, setselectNameOrRollNum] = useState('');

  const handleSelectChangeNameOrRoll = (e) => {
    setselectNameOrRollNum(e.target.value);
  };
  const [selectValueBatch1, setSelectValueBatch1] = useState([]);

  const [selectValueBatch, setSelectValueBatch] = useState('');
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };
  const [selectValueExamCycle1, setSelectValueExamCycle1] = useState([]);

  const [selectValueExamCycle, setSelectValueExamCycle] = useState('');
  const handleSelectChangeExamCycle = (e) => {
    setSelectValueExamCycle(e.target.value);
  };

  const [selectValueExamType, setSelectValueExamType] = useState('');
  const handleSelectChangeExamType = (e) => {
    setSelectValueExamType(e.target.value);
  };

  const [selectValueExamDate, setSelectValueExamDate] = useState('');
  const handleSelectChangeExamDate = (e) => {
    setSelectValueExamDate(e.target.value);
  };
  // const [selectStatusValueUpcomomgExam, setSelectStatusValueUpcomomgExam] =
  //   useState(selectStatusOptionsUpcomomgExam[0].value);

  const [selectDueInValueUpcomomgExam, setSelectDueInValueUpcomomgExam] =
    useState(selectDueInOptions[0].value);

  const [upcomingExamData, setUpcomingExamData] = useState([]);
  const [completedExamData, setcompletedExamData] = useState([]);
  const [examProgressData, setExamProgressData] = useState([]);
  const [studentInRiskData, setStudentInRiskData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectDueDaysValue, setDueDaysValue] = useState('');
  const [courseWithoutExam, setCourseWithoutExam] = useState([]);

  // For Filter
  const [filterData, setFilterData] = useState();

  const [examMonthData, setExamMonthData] = useState([]);
  const [selectCourseData, setselectCourseData] = useState([]);
  const [selectTermData, setselectTermData] = useState([]);
  const [selectCampusData, setselectCampusData] = useState([]);
  const [selectProgramData, setselectProgramData] = useState([]);

  const handleSelectDueInChangeUpcomomgExam = (e) => {
    setSelectDueInValueUpcomomgExam(e.target.value);
  };

  const ProgressActionCell = (row) => {
    const classes = useStyles();
    const { id, actions } = row.row.values;
    const [filterDialog, setFilterDialog] = useState(false);
    // const handleClickSeatView = () => {
    //   history.push(`/app/exam/`);
    // };

    function handleFilterDialog() {
      setFilterDialog((prevState) => !prevState);
    }

    const handleClickSeatGrading = () => {
      history.push(`/app/exam/faculty-Proctoring`);
    };
    return (
      <Box>
        <Button
          className={classes.grayLink}
          size="small"
          component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
          // onClick={() => handleClickSeatGrading()}
          target="_blank"
          to={`${routes.webCamScreen}`}
        >
          View
        </Button>
        {/* <KenDialogBox
            title={
              <Typography variant="h6" className={classes.dialogHeader}>
                Web Cam
              </Typography>
            }
            icon={<RiCheckFill />}
            open={filterDialog}
            handleClose={() => handleFilterDialog()}
            negativeButtonClick={() => handleFilterDialog()}
            positiveButtonClick={() => handleFilterDialog()}
            positiveButtonText="Apply"
            negativeButtonText="Clear"
            maxWidth={'s'}
            dividers
          >
            <Webcam width={1100} height={450} />,
          </KenDialogBox> */}
      </Box>
    );
  };

  const columnsProgress = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'Program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course',
      accessor: 'subject',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Date',
      accessor: 'examDate',
      disableGlobalFilter: true,
    },
    // {
    //   Header: 'Exam Cycle',
    //   accessor: 'examCycle',
    //   disableGlobalFilter: true,
    // },
    // {
    //   Header: 'Batch',
    //   accessor: 'batch',
    //   disableGlobalFilter: true,
    // },
    {
      Header: 'Type',
      accessor: 'type',
      disableGlobalFilter: true,
    },
    {
      Header: 'Venue / Link',
      accessor: 'actions',
      Cell: ProgressActionCell,
    },
  ];

  const [selectDueInValueCompletedExam, setSelectDueInValueCompletedExam] =
    useState(selectDueInOptions[0].value);

  const [viewCompletedAll, setCompletedviewAll] = useState(false);
  const [viewPendingAll, setPendingviewAll] = useState(false);
  const [viewInprogressAll, setInprogressviewAll] = useState(false);
  const [viewStdRiskAll, setStdRiskviewAll] = useState(false);
  const onViewAllInprogress = () => {
    history.push('/app/exam/ExamProgress');
    setInprogressviewAll(true);
  };

  let completedExamDataWithLimit;

  useEffect(() => {
    getExamModuleListData().then((res) => {
      console.log('resresresresresresres', res);
      setFilterData(res);
    });
  }, []);

  useEffect(() => {
    let TermListData = filterData?.TermList?.map((item) => {
      return {
        label: item?.TermName,
        value: item?.TermName,
      };
    });
    setselectTermData(TermListData);

    // For Course
    let CourseListData = filterData?.CourseList?.filter((item) => {
      return (
        selectValueCampus == item?.TermName &&
        item?.TermName &&
        item?.CourseName
      );
    }).map((item) => {
      return {
        label: item?.CourseName,
        value: item?.CourseName,
      };
    });

    setselectCourseData(CourseListData);

    let CampusListData = filterData?.campus.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setselectCampusData(CampusListData);

    let BatchListData = filterData?.batchList
      .filter((item) => {
        return item != null;
      })
      .map((item) => {
        return {
          label: item,
          value: item,
        };
      });

    setSelectValueBatch1(BatchListData);

    let ProgramListData = filterData?.ProgrameList.filter((item) => {
      return item?.ProgrameName != null;
    }).map((item) => {
      return {
        label: item?.ProgrameName,
        value: item?.ProgrameName,
      };
    });

    setselectProgramData(ProgramListData);

    let ExamCycleListData = filterData?.ExamMonthList.filter((item) => {
      return item != null;
    }).map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setSelectValueExamCycle1(ExamCycleListData);
    // let CampusListData = filterData?.campus.map((item) => {
    //   return {
    //     label: item,
    //     value: item,
    //   };
    // });
    // setselectCampusData(CampusListData);
  }, [filterData, selectValueCampus]);

  const getExamDatsa = () => {
    let filterData = {
      comduedays: selectDueInValueCompletedExam,
      pendingDueDate: selectDueInValueUpcomomgExam,
    };
    setLoading(true);

    getExamData(filterData)
      .then((res) => {
        setLoading(false);
        console.log('resresresresresForExam', res);
        let dataExamInProgress =
          res.inProgressExamList === null
            ? []
            : res.inProgressExamList.map((item, index) => {
                console.log('itemitemitemitem', item);
                return {
                  id: item?.id,
                  program: item.program ? item.program : 'N/A',
                  subject: item.course ? item.course : 'N/A',
                  type: item.examType ? item.examType : 'N/A',
                  actions: item.examLink ? item.examLink : 'Venue',
                  // batch: item.batch ? item.batch : '',
                  // examCycle: item.examCycle ? item.examCycle : '',
                  examDate: item.examDate ? item.examDate : '',
                };
              });
        setExamProgressData(dataExamInProgress);
      })
      .catch((err) => {
        setLoading(false);
        console.log('err', err);
      });
  };

  useEffect(() => {
    getExamDatsa();
    setLoading(true);
  }, [
    selectDueInValueCompletedExam,

    selectDueInValueUpcomomgExam,
    viewPendingAll,
    viewCompletedAll,
  ]);

  completedExamDataWithLimit =
    completedExamData === null ? [] : completedExamData.slice(0, 5);
  const progressExamDataWithLimit =
    examProgressData === null ? [] : examProgressData.slice(0, 5);
  const UpcomingExamDataWithLimit =
    upcomingExamData === null ? [] : upcomingExamData;
  const viewStdRiskAllData = courseWithoutExam.slice(0, 5);

  return (
    <>
      <Box>
        {loading && <KenLoader />}
        <Box className={`${classes.breadCrumbWrapper} ${'breadCrumbText'}`}>
          <BreadCrumb
            className="breadCrumbText"
            array={arrayBreadCrumb}
            history={history}
          />
        </Box>
        <Box className={`${classes.gridKenClass} cardlsitbox`}>
          <HeaderGrid1
            title="Exams in Progress"
            columns={columnsProgress}
            count={examProgressData.length}
            data={
              viewInprogressAll ? examProgressData : progressExamDataWithLimit
            }
            onViewAll={onViewAllInprogress}
            onFilterClick={handleFilterDialog}
          />
        </Box>{' '}
        {/* Filter Modal */}
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              EXAM FILTER
            </Typography>
          }
          open={filterDialog}
          handleClose={() => handleFilterDialog()}
          negativeButtonClick={() => handleFilterDialog()}
          // positiveButtonClick={() => getStudentData()}
          positiveButtonText="Submit"
          negativeButtonText="Cancel"
          dividers
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <KenSelectWrap
                label="Program"
                options={selectProgramData}
                value={selectValueProgram}
                dropdownColor="#FFFFFF"
                onChange={handleSelectChangePrograms}
                required
              />{' '}
            </Grid>
            <Grid item xs={12} sm={6}>
              <KenSelectWrap
                label="Term"
                options={selectTermData}
                value={selectValueCampus}
                dropdownColor="#FFFFFF"
                onChange={handleSelectChangeCampus}
                required
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <KenInputField
                label="Reason"
                value={selectReason}
                dropdownColor="#FFFFFF"
                onChange={handleSelectChangeRes}
                className="abssssssssss"
                required
              />
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <KenSelectWrap
                label="Course"
                options={selectCourseData}
                value={selectValueSubject}
                dropdownColor="#FFFFFF"
                onChange={handleSelectChangeProgram}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <KenSelectWrap
                label="Exam Type"
                options={selectExamTypeOptions}
                value={selectValueExamType}
                dropdownColor="#FFFFFF"
                onChange={handleSelectChangeExamType}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <KenDateTimePicker
                label="Exam Date"
                inputBaseRootClass={classes.kenDateTimePickerColor}
                placeholder="Exam Date"
                value={selectValueExamDate}
                type="date"
                required={true}
                defaultValue={selectValueExamDate}
                onChange={handleSelectChangeExamDate}
              />
            </Grid>
          </Grid>
        </KenDialogBox>
      </Box>
    </>
  );
};

export default ExamProgress;
